import { Suspense } from "react";
import { connect } from "react-redux";

import {
  ApplicationContext,
  configureApplication,
  Intl,
  Layout,
  locationShape,
  sessionShape,
  SessionHandler,
  url,
  Loader,
} from "lcm-iot-commons";
import Navigation from "../components/Navigation";
import { mergeAppMessages } from "../translations";

configureApplication({
  BASE_URL: "/app/id",
});

const UNSECURED_ENDPOINTS = [
  url("/sign_in"),
  url("/sign_up"),
  url("/sign_up_success"),
  url("/sign_up_complete"),
  url("/session_expired"),
  url("/sign_in_confirmation"),
  url("/request_password_reset"),
  url("/password_reset"),
  url("/confirmation"),
  url("/404"),
  url("/403"),
  url("/500"),
];

type OwnRootProps = {
  session?: sessionShape;
  children: React.ReactNode;
  location?: locationShape;
};

const defaultProps: Partial<OwnRootProps> = {
  session: undefined,
  location: undefined,
};

type RootProps = OwnRootProps & typeof defaultProps;

export function Root({ session, location, children }: RootProps) {
  return (
    <Suspense fallback={<Loader />}>
      {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; location: locationShape... Remove this comment to see the full error message */}
      <SessionHandler
        location={location}
        unsecuredEndpoints={UNSECURED_ENDPOINTS}
      >
        <Intl mergeAppMessages={mergeAppMessages}>
          {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element[]; unsecuredEndpoints: s... Remove this comment to see the full error message */}
          <ApplicationContext unsecuredEndpoints={UNSECURED_ENDPOINTS}>
            {/* @ts-expect-error TS(2322) FIXME: Type '{ location: locationShape | undefined; showN... Remove this comment to see the full error message */}
            <Navigation location={location} showNavigationItems />
            <div className="navbar-separator" />
            {/* @ts-expect-error TS(2322) FIXME: Type '{ children: ReactNode; authenticated: boolea... Remove this comment to see the full error message */}
            <Layout authenticated={session.authenticated}>{children}</Layout>
          </ApplicationContext>
        </Intl>
      </SessionHandler>
    </Suspense>
  );
}

Root.defaultProps = defaultProps;

const mapStateToProps = (state: $TSFixMe) => ({
  session: state.session,
});

// @ts-expect-error TS(2345) FIXME: Argument of type 'typeof Root' is not assignable t... Remove this comment to see the full error message
export default connect(mapStateToProps)(Root);
